module.exports = __webpack_public_path__ + "static/media/impulse_logo.2e61fb54.png";